var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',_vm._l((_vm.lines),function(line,i){return _c('line',_vm._b({key:i},'line',line,false))}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }